<template>
  <component class="Tag-Icon" :class="get_modify" :is="get_tag" :href="get_href" target="_blank">
    <AvatarImage class="Tag-Icon__icon" :src="props.image" :size="16" :alt="'resource'" />
  </component>
</template>

<script setup>
  import { defineProps, computed } from 'vue';
  import { Props } from './scripts/props.js';
  //-----------------------------------------------
  import AvatarImage from '@ui/Images/AvatarImage/AvatarImage.vue';
  //-----------------------------------------------
  const props = defineProps(Props());
  //-----------------------------------------------
  //Определить, блок является ссылкой?
  const get_tag = computed(() => props.link ? 'a' : 'span');
  //Определить класс модификатор
  const get_modify = computed(() => props.link ? 'Tag-Icon-Value--link' : '');
  //Определить атрибут href
  const get_href = computed(() => props.link ? props.link : null );
</script>

<style lang="scss">
  @import "./styles/_conf";
</style>